var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("EnviarPermisoFuncionarioJefe"),
      _vm._v(" "),
      _c("EnviarPermiso"),
      _vm._v(" "),
      _c("EnviarPermisoRRHH"),
      _vm._v(" "),
      _c("AddSolicitud"),
      _vm._v(" "),
      _c("VerPermiso"),
      _vm._v(" "),
      _c("VerReporte"),
      _vm._v(" "),
      _c("ver-seguimiento"),
      _vm._v(" "),
      _c("AnularPermiso"),
      _vm._v(" "),
      _c("AprobarRRHHSinPermisos"),
      _vm._v(" "),
      _c("AprobarPermiso"),
      _vm._v(" "),
      _c("AprobarPermisoRRHH"),
      _vm._v(" "),
      _c("RechazarPermisoRRHH"),
      _vm._v(" "),
      _c("ReenviarPermiso"),
      _vm._v(" "),
      _c("ModificarPermiso"),
      _vm._v(" "),
      _c("ModificarPermisoCompensacion"),
      _vm._v(" "),
      _c("ModificarPermisoToleranciaCompensacion"),
      _vm._v(" "),
      _c("EditarPermisoCargoVacacion"),
      _vm._v(" "),
      _c("compensar-permiso"),
      _vm._v(" "),
      _c("CompensarPermisoParticular"),
      _vm._v(" "),
      _c("CompensarPermisoTolerancia"),
      _vm._v(" "),
      _c("VerDocumento"),
      _vm._v(" "),
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { info: "" } }, [_vm._v("exit_to_app")]),
          _vm._v(
            _vm._s(_vm.titulo_permiso) +
              " de permisos,\n      licencias, y omisiones\n    "
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.$route.params.id
        ? _c(
            "v-btn",
            { attrs: { icon: "", color: "primary", to: "/permisos/rrhh" } },
            [_c("v-icon", [_vm._v("arrow_back")])],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "", md6: "" } },
        [
          _c("v-autocomplete", {
            staticClass: "text-field-reducido-border",
            attrs: {
              items: _vm.lista_gestiones,
              "item-text": "periodo",
              "item-value": "periodo",
              label: "Seleccione la gestión",
              required: "",
              outline: "",
              success: "",
              clearable: ""
            },
            on: {
              change: function($event) {
                return _vm.actualizaCrudTable()
              }
            },
            model: {
              value: _vm.periodo_seleccionado,
              callback: function($$v) {
                _vm.periodo_seleccionado = $$v
              },
              expression: "periodo_seleccionado"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      !_vm.esUsuario
        ? _c(
            "h4",
            { staticStyle: { color: "#000" } },
            [
              _c("b", [_vm._v("NOMBRE COMPLETO:")]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" " + _vm._s(_vm.nombres) + "\n    ")
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _vm.sw_crud_table
                ? _c(
                    "crud-table",
                    {
                      staticClass: "tabla-comprimida-light tabla-permisos",
                      attrs: {
                        headers: _vm.headers,
                        url: _vm.url,
                        filters: _vm.filters,
                        graphql: _vm.graphql,
                        "data-graphql": _vm.dataGraphql,
                        initData: _vm.initData,
                        widthModal: 840
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "items",
                            fn: function(items) {
                              return [
                                _c("td", [_vm._v(_vm._s(items.item.numero))]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(items.item.fecha_emision))
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(items.item.fecha_desde))
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(items.item.fecha_retorno))
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(items.item.tipo_permiso))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-center" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        items.item.horas_permiso == null
                                          ? "00:00"
                                          : _vm
                                              .$moment(
                                                items.item.horas_permiso,
                                                "HH:mm"
                                              )
                                              .format("HH:mm")
                                      ) +
                                      "\n            "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        items.item.id_tipo_permiso == 90 &&
                                          items.item.motivo !=
                                            "OTROS(ENFERMEDAD COMUN,RIESGO PROFESIONAL, RIESGO EXTRAORDINARIO)"
                                          ? items.item.motivo
                                          : items.item.motivo ==
                                              "OTROS(ENFERMEDAD COMUN,RIESGO PROFESIONAL, RIESGO EXTRAORDINARIO)" &&
                                            items.item.id_tipo_permiso == 90
                                          ? "OTROS"
                                          : "OTROS"
                                      ) +
                                      "\n            "
                                  )
                                ]),
                                _vm._v(" "),
                                items.item.id_tipo_permiso == 8 ||
                                items.item.id_tipo_permiso == 24 ||
                                (items.item.id_tipo_permiso >= 37 &&
                                  items.item.id_tipo_permiso <= 43) ||
                                items.item.id_tipo_permiso == 87 ||
                                items.item.id_tipo_permiso == 104 ||
                                items.item.id_tipo_permiso == 103 ||
                                items.item.id_tipo_permiso == 88 ||
                                items.item.id_tipo_permiso == 89 ||
                                items.item.id_tipo_permiso == 94 ||
                                items.item.id_tipo_permiso == 96 ||
                                items.item.id_tipo_permiso == 98 ||
                                items.item.id_tipo_permiso == 99 ||
                                items.item.id_tipo_permiso == 100 ||
                                items.item.id_tipo_permiso == 101 ||
                                items.item.id_tipo_permiso == 102 ||
                                items.item.id_tipo_permiso == 5
                                  ? _c("td", [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm
                                              .$moment(
                                                items.item.hora_desde,
                                                "HH:mm:ss"
                                              )
                                              .format("HH:mm")
                                          ) +
                                          "\n            "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                [90, 18, 95, 44, 6, 61, 14, 105, 12].includes(
                                  parseInt(items.item.id_tipo_permiso)
                                )
                                  ? _c("td", [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s("") +
                                          "\n            "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                items.item.id_tipo_permiso == 8 ||
                                items.item.id_tipo_permiso == 24 ||
                                (items.item.id_tipo_permiso >= 37 &&
                                  items.item.id_tipo_permiso <= 43) ||
                                items.item.id_tipo_permiso == 87 ||
                                items.item.id_tipo_permiso == 104 ||
                                items.item.id_tipo_permiso == 88 ||
                                items.item.id_tipo_permiso == 89 ||
                                items.item.id_tipo_permiso == 94 ||
                                items.item.id_tipo_permiso == 96 ||
                                items.item.id_tipo_permiso == 98 ||
                                items.item.id_tipo_permiso == 99 ||
                                items.item.id_tipo_permiso == 100 ||
                                items.item.id_tipo_permiso == 102 ||
                                items.item.id_tipo_permiso == 101 ||
                                items.item.id_tipo_permiso == 103 ||
                                items.item.id_tipo_permiso == 5
                                  ? _c("td", [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm
                                              .$moment(
                                                items.item.hora_hasta,
                                                "HH:mm:ss"
                                              )
                                              .format("HH:mm")
                                          ) +
                                          "\n            "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                [90, 18, 95, 44, 6, 61, 14, 105, 12].includes(
                                  parseInt(items.item.id_tipo_permiso)
                                )
                                  ? _c("td", [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s("") +
                                          "\n            "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(items.item.nro_dias) +
                                      "\n            "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.obtenerNombreDestinatario(
                                          items.item
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        items.item.rechazo
                                          ? items.item.rechazo
                                          : items.item.justificacion
                                          ? items.item.justificacion
                                          : ""
                                      ) +
                                      "\n            "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        items.item.permiso.id_estado == 7 &&
                                          (items.item.permiso.id_tipo_permiso ==
                                            8 ||
                                            items.item.permiso
                                              .id_tipo_permiso == 98 ||
                                            items.item.permiso
                                              .id_tipo_permiso == 99 ||
                                            items.item.permiso
                                              .id_tipo_permiso == 100 ||
                                            items.item.permiso
                                              .id_tipo_permiso == 101 ||
                                            items.item.permiso
                                              .id_tipo_permiso == 89 ||
                                            items.item.permiso
                                              .id_tipo_permiso == 96 ||
                                            items.item.permiso
                                              .id_tipo_permiso == 95)
                                          ? "Aprobado"
                                          : items.item.estado_permiso
                                      ) +
                                      "\n            "
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.$route.params.id == undefined
                                  ? _c("td", [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            items.item.entregado == true
                                              ? "ENTREGADO"
                                              : "NO ENTREGADO"
                                          ) +
                                          "\n            "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.$route.params.id !== undefined
                                  ? _c(
                                      "td",
                                      [
                                        _c(
                                          "v-tooltip",
                                          { attrs: { bottom: "" } },
                                          [
                                            _c("v-checkbox", {
                                              attrs: {
                                                slot: "activator",
                                                primary: "",
                                                "model-value": true,
                                                "hide-details": ""
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.documentoEntregado(
                                                    items.item
                                                  )
                                                }
                                              },
                                              slot: "activator",
                                              model: {
                                                value: items.item.entregado,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    items.item,
                                                    "entregado",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "items.item.entregado"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  items.item.entregado
                                                    ? "Desmarcar"
                                                    : "Marcar"
                                                )
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "contenedor-botones" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          color: "info",
                                          icon: "",
                                          title: "Ver permiso"
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.verPermiso(items.item)
                                          }
                                        }
                                      },
                                      [
                                        _c("v-icon", [_vm._v("remove_red_eye")])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    (items.item.permiso.id_tipo_permiso != 95 &&
                                      //items.item.permiso.id_tipo_permiso != 98 &&
                                      //items.item.permiso.id_tipo_permiso != 99 &&
                                      items.item.permiso.id_tipo_permiso !=
                                        100 &&
                                      items.item.permiso.id_tipo_permiso !=
                                        101 &&
                                      //// WC
                                      //items.item.permiso.id_tipo_permiso != 103 &&
                                      //items.item.permiso.id_tipo_permiso != 90 &&
                                      //items.item.permiso.id_tipo_permiso != 18 &&
                                      ///
                                      items.item.permiso.id_tipo_permiso != 8 &&
                                      (items.item.permiso.id_estado == 7 ||
                                        items.item.permiso.id_estado == 6 ||
                                        items.item.permiso.id_estado == 21 ||
                                        items.item.permiso.id_estado == 77 ||
                                        items.item.permiso.id_estado == 75)) ||
                                    (items.item.permiso.id_tipo_permiso == 89 &&
                                      (items.item.permiso.id_estado == 22 ||
                                        items.item.permiso.id_estado == 77 ||
                                        items.item.permiso.id_estado == 6))
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "#F58736",
                                              icon: "",
                                              title: "Ver reporte"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.verReporte(
                                                  items.item
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("v-icon", [
                                              _vm._v("picture_as_pdf")
                                            ])
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    items.item.permiso.id_estado == 22 &&
                                    items.item.permiso.id_tipo_permiso == 96
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "warning",
                                              icon: "",
                                              title: "Modificar permiso"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.modificarPermisoToleranciaCompensacion(
                                                  items.item
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("edit")])],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    items.item.permiso.id_estado == 22 &&
                                    (items.item.permiso.id_tipo_permiso == 90 ||
                                      items.item.permiso.id_tipo_permiso == 44)
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "warning",
                                              icon: "",
                                              title: "Modificar"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.modificarPermiso(
                                                  items.item
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("edit")])],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    items.item.permiso.id_estado == 22 &&
                                    items.item.permiso.id_tipo_permiso != 24 &&
                                      items.item.permiso.id_tipo_permiso !=
                                        96 &&
                                      items.item.permiso.id_tipo_permiso !=
                                        90 &&
                                      items.item.permiso.id_tipo_permiso != 44
                                      ? //|| ($route.params.id == undefined && items.item.permiso.id_tipo_permiso !== 105)

                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "warning",
                                              icon: "",
                                              title: "Modificar"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.modificarPermiso(
                                                  items.item
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("edit")])],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    items.item.permiso.id_estado == 22 &&
                                    items.item.permiso.id_tipo_permiso == 24
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "warning",
                                              icon: "",
                                              title: "Modificar"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.editarPermisoCargoVacacion(
                                                  items.item
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("edit")])],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    (items.item.permiso.id_estado == 22 &&
                                      items.item.permiso.id_tipo_permiso ==
                                        96 &&
                                      !_vm.$route.params.id) ||
                                    (items.item.permiso.id_estado != 9 &&
                                      items.item.permiso.id_tipo_permiso ==
                                        96 &&
                                      _vm.$route.params.id)
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "red",
                                              icon: "",
                                              dark: "",
                                              title: "Anular"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.anularPermiso(
                                                  items.item
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("delete")])],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    (items.item.permiso.id_estado == 22 &&
                                      (items.item.permiso.id_tipo_permiso ==
                                        90 ||
                                        items.item.permiso.id_tipo_permiso ==
                                          44) &&
                                      !_vm.$route.params.id) ||
                                    (items.item.permiso.id_estado != 9 &&
                                      (items.item.permiso.id_tipo_permiso ==
                                        90 ||
                                        items.item.permiso.id_tipo_permiso ==
                                          44) &&
                                      _vm.$route.params.id)
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "red",
                                              icon: "",
                                              dark: "",
                                              title: "Anular"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.anularPermiso(
                                                  items.item
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("delete")])],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    (items.item.permiso.id_estado == 22 &&
                                      items.item.permiso.id_tipo_permiso !=
                                        96 &&
                                      items.item.permiso.id_tipo_permiso !=
                                        90 &&
                                      items.item.permiso.id_tipo_permiso !=
                                        44 &&
                                      !_vm.$route.params.id) ||
                                    (items.item.permiso.id_estado != 9 &&
                                      items.item.permiso.id_tipo_permiso !=
                                        96 &&
                                      items.item.permiso.id_tipo_permiso !=
                                        90 &&
                                      items.item.permiso.id_tipo_permiso !=
                                        44 &&
                                      _vm.$route.params.id)
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "red",
                                              icon: "",
                                              dark: "",
                                              title: "Anular"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.anularPermiso(
                                                  items.item
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("delete")])],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    items.item.permiso.ruta_archivo
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              icon: "",
                                              color: "info",
                                              title: "Ver documento"
                                            },
                                            nativeOn: {
                                              click: function($event) {
                                                return _vm.verDocumento(
                                                  items.item.permiso
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("v-icon", [
                                              _vm._v("attach_file")
                                            ])
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.$route.params.id !== undefined
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "#E61C5B",
                                              dark: "",
                                              icon: "",
                                              title: "Rechazar permiso"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.rechazarPermisoRRHH(
                                                  items.item
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("close")])],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    items.item.permiso.id_estado == 6 &&
                                    _vm.$route.params.id !== undefined
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "#E61C5B",
                                              dark: "",
                                              icon: "",
                                              title: "Reenviar permiso"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.reenviarPermiso(
                                                  items.item
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("mail")])],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.mostrarBotonEnviarJefe(items.item)
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "success",
                                              icon: "",
                                              title: "Enviar IS"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.enviarPermisoFuncionarioJefe(
                                                  items.item
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("send")])],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.mostrarBotonEnviarGeneral(items.item)
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "success",
                                              icon: "",
                                              title: "Enviar G"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.enviarPermiso(
                                                  items.item
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("send")])],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.mostrarBotonEnviarRRHH(items.item)
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "success",
                                              icon: "",
                                              title: "Enviar RRHH"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.enviarPermisoRRHH(
                                                  items.item
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("send")])],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.mostrarBotonServidorPublico(items.item)
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "success",
                                              icon: "",
                                              title: "Enviar SP"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.enviarPermiso(
                                                  items.item
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("send")])],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "v-tooltip",
                                      { attrs: { bottom: "" } },
                                      [
                                        (items.item.permiso.id_estado == 22 ||
                                          items.item.permiso.id_estado == 21 ||
                                          items.item.permiso.id_estado == 6) &&
                                        _vm.$route.params.id !== undefined
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  slot: "activator",
                                                  color: "warning",
                                                  icon: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.aprobarRRHHSinPermisos(
                                                      items.item
                                                    )
                                                  }
                                                },
                                                slot: "activator"
                                              },
                                              [
                                                _c("v-icon", [
                                                  _vm._v("done_all")
                                                ])
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v("Aprobar super usuario")
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1578295254
                      )
                    },
                    [
                      _c(
                        "template",
                        { slot: "buttons" },
                        [
                          _vm.esUsuario
                            ? _c(
                                "v-tooltip",
                                { attrs: { bottom: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        slot: "activator",
                                        color: "primary",
                                        to: "/permisos/crear/"
                                      },
                                      slot: "activator"
                                    },
                                    [
                                      _c("v-icon", [_vm._v("event_note")]),
                                      _vm._v(" Nueva Solicitud\n              ")
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Crear nuevo permiso")])
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.esUsuario
                        ? _c(
                            "template",
                            { slot: "buttons" },
                            [
                              _c(
                                "v-tooltip",
                                { attrs: { bottom: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        slot: "activator",
                                        color: "primary",
                                        to:
                                          "/permisos/crearRRHH/" +
                                          _vm.getPersonaId()
                                      },
                                      slot: "activator"
                                    },
                                    [
                                      _c("v-icon", [_vm._v("event_note")]),
                                      _vm._v(" Nueva Solicitud\n              ")
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Crear nuevo permiso")])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-spacer", [_c("br")]),
      _vm._v(" "),
      _c(
        "v-tooltip",
        { attrs: { bottom: "" } },
        [
          _c(
            "v-btn",
            {
              attrs: { slot: "activator", color: "green", dark: "" },
              on: {
                click: function() {
                  _vm.bandera_calendario
                    ? (_vm.bandera_calendario = false)
                    : (_vm.bandera_calendario = true)
                }
              },
              slot: "activator"
            },
            [
              _c("v-icon", [_vm._v("event_note")]),
              _vm._v(
                _vm._s(
                  _vm.bandera_calendario
                    ? "Ocultar calendario"
                    : "Mostrar calendario"
                ) + "\n      "
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("span", [_vm._v("Mostrar calendario")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.bandera_calendario,
              expression: "bandera_calendario"
            }
          ]
        },
        [
          _c("h1", { staticClass: "primary--text" }, [_vm._v("Calendario")]),
          _vm._v(" "),
          _c(
            "v-layout",
            [
              _c(
                "v-flex",
                [
                  _c(
                    "v-sheet",
                    { attrs: { height: "500" } },
                    [
                      _c("v-calendar", {
                        ref: "calendar",
                        attrs: {
                          type: "month",
                          end: _vm.end,
                          value: _vm.today,
                          color: "primary",
                          locale: "es"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "day",
                            fn: function(ref) {
                              var date = ref.date
                              return _vm._l(_vm.eventsMap[date], function(
                                event
                              ) {
                                return _c(
                                  "v-card",
                                  { key: event.id },
                                  [
                                    _c(
                                      "v-menu",
                                      {
                                        attrs: {
                                          "full-width": "",
                                          "offset-x": ""
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var on = ref.on
                                                return [
                                                  !event.time
                                                    ? _c(
                                                        "div",
                                                        _vm._g(
                                                          {
                                                            class:
                                                              event.estado == 7
                                                                ? "permiso-aprobado"
                                                                : "permiso-rechazado",
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                event.title
                                                              )
                                                            }
                                                          },
                                                          on
                                                        )
                                                      )
                                                    : _vm._e()
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value: event.open,
                                          callback: function($$v) {
                                            _vm.$set(event, "open", $$v)
                                          },
                                          expression: "event.open"
                                        }
                                      },
                                      [
                                        _vm._v(" "),
                                        _c(
                                          "v-card",
                                          {
                                            attrs: {
                                              color: "grey lighten-4",
                                              "min-width": "350px",
                                              flat: ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-toolbar",
                                              {
                                                attrs: {
                                                  color: "primary",
                                                  dark: ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-btn",
                                                  { attrs: { icon: "" } },
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v("edit")
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("v-toolbar-title", [
                                                  _c("div", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        event.title
                                                      )
                                                    }
                                                  })
                                                ]),
                                                _vm._v(" "),
                                                _c("v-spacer")
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-card-title",
                                              {
                                                attrs: { "primary-title": "" }
                                              },
                                              [
                                                _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      event.details
                                                    )
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-card-actions",
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      flat: "",
                                                      color: "blue"
                                                    }
                                                  },
                                                  [_vm._v(" Cerrar ")]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              })
                            }
                          }
                        ]),
                        model: {
                          value: _vm.start,
                          callback: function($$v) {
                            _vm.start = $$v
                          },
                          expression: "start"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      on: {
                        click: function($event) {
                          return _vm.$refs.calendar.prev()
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { dark: "", left: "" } }, [
                        _vm._v(" keyboard_arrow_left ")
                      ]),
                      _vm._v("\n            Anterior\n          ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      on: {
                        click: function($event) {
                          return _vm.$refs.calendar.next()
                        }
                      }
                    },
                    [
                      _vm._v("\n            Siguiente\n            "),
                      _c("v-icon", { attrs: { right: "", dark: "" } }, [
                        _vm._v(" keyboard_arrow_right ")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0531d6db", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0531d6db","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/permiso/Permiso.vue
// module id = null
// module chunks = 